import theme from "app/Theme/Theme";
import React from "react";
import { ActivityIndicator } from "react-native";

const Spinner = ({ size, color = theme.colors["neutral.350"] }) => {
  return <ActivityIndicator color={color} size={size || "large"} />;
};

export { Spinner };
